import { INACTIVE_RECURRING_RULE, MESSAGE_BAR_TYPES } from "../../utils/constants";
import { getRecurringRule, setupRecurringPaymentApi, updateRecurringPaymentApi, updateRecurringStatus } from "../api"
import { GET_RECURRING_DATA, SHOW_MESSAGE } from "./actionTypes";

export const getReccuringRules = () => async (dispatch) => {
    try {
        const response = await getRecurringRule();
        const active = response?.result?.rules;
        dispatch({
            type: GET_RECURRING_DATA,
            payload: active
        })
    } catch (err) {
        // handle error
    }
}

export const saveRecurringRules = (payload, onSuccess, onFailure) => async (dispatch) => {
    try {
        await setupRecurringPaymentApi(payload);
        if (typeof onSuccess === 'function') onSuccess();
    } catch (err) {
        if (typeof onFailure === 'function') onFailure();
        dispatch({
            type: SHOW_MESSAGE,
            payload: {
                type: MESSAGE_BAR_TYPES.ERROR,
                message: err?.response?.data?.message || err.message,
            },
        });
    }
}


export const updateRecurringRules = (payload, onSuccess, onFailure) => async (dispatch) => {
    try {
        await updateRecurringPaymentApi(payload);
        if (typeof onSuccess === 'function') onSuccess();
    } catch (err) {
        if (typeof onFailure === 'function') onFailure();
        dispatch({
            type: SHOW_MESSAGE,
            payload: {
                type: MESSAGE_BAR_TYPES.ERROR,
                message: err?.response?.data?.message || err.message,
            },
        });
    }
}

export const cancelRecurringRule = (uuid, onSuccess, onFailure) => async (dispatch) => {
    try {
        const data = {
            ruleId: uuid,
            status: INACTIVE_RECURRING_RULE
        }
        await updateRecurringStatus(data);
        if (typeof onSuccess === 'function') onSuccess();
    } catch (err) {
        if (typeof onFailure === 'function') onFailure();
        dispatch({
            type: SHOW_MESSAGE,
            payload: {
                type: MESSAGE_BAR_TYPES.ERROR,
                message: err?.response?.data?.message || err.message,
            },
        });
    }
}